module.exports = {
    ENV: 'prod',
    APP_NAME: 'ape',
    END_POINT: 'https://ssm.services.apihf.com',
    API_KEY: 'a1Jv8beujQal0VvdxItVp8rVre8D3xFp5DYNAavt',
    BRAND_KEY: '8131cde5-4b5b-45c2-9139-18de50bf7fa5',
    LANG: 'fr-FR'
}